import flex from "@/utils/flex";
import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import FooterDialog from "./FooterDialog";
import i18n from "@/lang/i18n";
import { LANGUAGE } from "@/utils/Enum";
import { mobile } from "@/utils/responsive";
import { useTranslation } from "react-i18next";

interface PropsType {}

function FooterComposition(props: PropsType) {
  const { t } = useTranslation();
  const English = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const Korean = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const [selected, setSelected] = useState();
  const handleSelect = (e: any) => {
    setSelected(e);
  };

  useEffect(() => {
    if (selected === "한국어") {
      Korean(LANGUAGE.KOREAN);
    } else if (selected === "English") {
      English(LANGUAGE.ENGLISH);
    }
  }, [selected]);
  return (
    <FooterDialog>
      <CreationText>
        <div className="dev">{t("개발자들")}: &nbsp;</div>
        <div className="name">
          {t("고백재")}
          <a
            href="https://github.com/baeg-jae"
            target="_blank"
            rel="noreferrer"
          >
            <GitEmo />
          </a>
          &nbsp;
        </div>
        <div className="name">
          {t("김준호")}
          <a
            href="https://github.com/kevinkim910408"
            target="_blank"
            rel="noreferrer"
          >
            <GitEmo />
          </a>
          &nbsp;
        </div>
      </CreationText>
      <Container>
        <div> </div>

        <select
          className="translate"
          onChange={(e) => handleSelect(e.target.value)}
        >
          <option>한국어</option>
          <option>English</option>
        </select>
      </Container>
    </FooterDialog>
  );
}

export default FooterComposition;

const Container = styled.div`
  width: 50%;
  ${flex({ justify: "space-between" })}
  .translate {
    margin-right: 1rem;
    width: 150px;
    border: none;
    &:focus {
      outline: none;
    }
  }
  ${mobile(css`
    width: 40%;
  `)}
`;

const CreationText = styled.div`
  font-size: 1rem;
  ${flex({})}
  .name {
    ${flex({})}
    margin-left: 1rem;
  }
  ${mobile(css`
    font-size: 0.8rem;
    .dev {
      display: none;
    }
  `)}
`;

const GitEmo = styled.div`
  background-image: url("https://cdn-icons-png.flaticon.com/512/25/25231.png");
  background-size: cover;
  background-position: contain;
  width: 20px;
  height: 20px;
  margin-left: 0.5rem;
  ${mobile(css`
    width: 15px;
    height: 15px;
  `)}
`;
